import { CreditsType } from 'b2b-common/core/account/api/Credits.types';
import { CLEAR_ACCOUNT_CREDITS, FETCH_CREDITS, FETCH_CREDITS_FULFILLED, FETCH_CREDITS_REJECTED } from './actionTypes';
import type {
  ClearAccountCreditsAction,
  FetchCreditsAction,
  FetchCreditsFulfilledAction,
  FetchCreditsRejectedAction,
} from './types';

export const fetchCredits = (pageSize: number, startItem: number): FetchCreditsAction => ({
  type: FETCH_CREDITS,
  payload: {
    startItem,
    pageSize,
  },
});

export const fetchCreditsFulfilled = (response: CreditsType): FetchCreditsFulfilledAction => ({
  type: FETCH_CREDITS_FULFILLED,
  payload: {
    data: response,
  },
});

export const fetchCreditsRejected = (error: ErrorType): FetchCreditsRejectedAction => ({
  type: FETCH_CREDITS_REJECTED,
  payload: {
    error,
  },
});

export const clearAccountCredits = (): ClearAccountCreditsAction => ({
  type: CLEAR_ACCOUNT_CREDITS,
});
